export default __webpack_public_path__ + "static/media/016-the Oscars.ed435e3f.svg";